export const PAYMENT_DISCOUNT_MAX_RETRIES_REACHED = 'PAYMENT_DISCOUNT_MAX_RETRIES_REACHED' as const;
export const PAYMENT_DISCOUNT_TOOLTIP_DISMISSED = 'PAYMENT_DISCOUNT_TOOLTIP_DISMISSED' as const;
export const SET_PAYMENT_METHOD_FILTER = 'SET_PAYMENT_METHOD_FILTER' as const;
